import { useEffect, useState } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../../firebaseConfig';

/**
 * Reads the user's spam-check preference from
 * /World/{uid}/settings/spamCheckSettings.
 * Returns 'rules' (default, hardcoded/free) or 'ai' (Intelligent Spam Analyzer).
 */
export default function useSpamCheckMode(userId) {
  const [mode, setMode] = useState('rules');

  useEffect(() => {
    if (!userId) return undefined;
    const settingsRef = ref(database, `/World/${userId}/settings/spamCheckSettings`);
    const unsub = onValue(settingsRef, (snap) => {
      const val = snap.val();
      setMode(val && val.mode === 'ai' ? 'ai' : 'rules');
    }, () => setMode('rules'));
    return () => unsub();
  }, [userId]);

  return mode;
}
